import { render, staticRenderFns } from "./b2cRejectDialog.vue?vue&type=template&id=597874e3&"
import script from "./b2cRejectDialog.vue?vue&type=script&lang=js&"
export * from "./b2cRejectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports